var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.625 19.653-3.223-3.224a5.519 5.519 0 1 0-.972.973l3.223 3.223.972-.972zm-7.562-2.466a4.124 4.124 0 1 1 0-8.248 4.124 4.124 0 0 1 0 8.248zM6.875 8.25h-5.5v1.375h5.5V8.25zM12.375 1.375h-11V2.75h11V1.375zM12.375 4.813h-11v1.375h11V4.813z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.db0f5298e70709af9d83c8a59c7de6c4.svg";
export { ForwardRef as ReactComponent };